const ITEMS = [
  "Scale Past Six Figures",
  "Trade With Conviction",
  "The 6 Figure Stock Trading Coach",
  "Paid Mentorship Only",
  "Break The Plateau",
  "Live The Life You Trade For",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0c0c0d] py-6"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {loop.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-['Playfair_Display'] text-2xl font-medium tracking-tight gold-metallic-text sm:text-3xl">
              {item}
            </span>
            <span className="text-[#d4af37]">&#9670;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
